import React, { Component } from "react";
import {
  TextField,
  Grid,
  Button,
  Paper,
  MenuItem,
  Typography,
  withStyles,
  FormGroup,
  FormControlLabel,
  Checkbox,
  ListSubheader,
  Tooltip,
} from "@material-ui/core";
import withServices from "../hocs/withServices";
import FileUpload from "./utils/FileUpload";
import Constants from "../common/constants";
import Loader from "./utils/Loader";

const styles = (theme) => ({
  root: {
    // '& .MuiFormControl-root': {
    //     width: '80%',
    //     margin: theme.spacing(1)
    // }
  },
  pageContent: {
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(0),
      padding: theme.spacing(1),
    },
  },
  txtField: {
    [theme.breakpoints.down("xs")]: {
      paddingTop: "20px",
    },
  },
});

const assessments = [
  {
    value: 2,
  },
  {
    value: 3,
  },
  {
    value: 4,
  },
  {
    value: 5,
  },
];

class EducationInfo extends Component {
  state = {
    loading: true,

    // Проверка был ли пользователь подтвержден техсекретарем
    isApproved: false,
    selectedGraduationPlaceCity: "",
    educationInstitutionTypes: [], // Универ, школа, колледж
    countries: [],
    localityTypes: [], // Типа населенного пункта (для КЗ)
    localities: [], // Населенный пункт (для КЗ) (kzGraduationLocality)
    distinctionMarkTypes: [],
    languages: [],
    selectedCountry: "",
    selectedLanguage: "",
    // Для школы KZ
    selectedKzGraduationLocalityType: "",
    selectedKzGraduationLocality: "", // Населенный пункт в КЗ
    // selectedKzEducationInstitution: '', // Название образовательного учрежден
    kzGraduationCertificateSeries: "", // Серия аттестата о среднем образовании
    kzGraduationCertificateNumber: "", // Номер свидетельства

    kzGraduationCertificateAveragePoint: 0.0, // Высчитывается по формуле
    graduationQualification: "",
    qualificationCommissionDecisionDate: "",

    kazakhLangAssessment: "",
    russianLangAssessment: "",

    selectedDistinctionMarkType: "",

    // И для иностранцев, и для KZ
    selectedEducationalInstitution: "", // educationalInstitution - для иностранцев (пишем вручную)
    selectedSchoolRegion: "",
    selectedSchoolStreet: "",
    selectedSchool: "",
    // Для иностранцев
    nostrificationCertificateNumber: "",
    nostrificationCertificateDate: "",

    // Файлы
    graduationCertificateIssueDate: "", // Дата выдачи сертификата об образовании
    graduationCertificate: "",
    copyGraduationCertificate: "",
    graduationCertificateApplication: "",
    graduationCertificateFileName: "", // Имя основного документа
    graduationCertificateApplicationFileName: "", // Имя документа с приложением

    graduationCertificateName: "", // Чисто для иностранцев

    specialityName: "",
    selectedEducationInstitutionType: "", // ID выбранного education institution type

    // Количество оценок
    numberOf5: 0,
    numberOf4: 0,
    numberOf3: 0,

    // Path (путь) загружаемых документов (graduationCertificate и graduationCertificateApplication)
    copyGraduationCertificatePath: "",
    graduationCertificatePath: "",
    graduationCertificateApplicationPath: "",

    regions: [],
    schoolStreets: [],
    resultSchoolStreets: [],
    schools: [],
    resultSchools: [],
    resultText: [],
    searchText: "",
    customInstitution: false,
  };

  fetchData() {
    const { educationInfo, secretary, auth } = this.props.services;

    (async () => {
      const educationInstitutionTypes = (
        await educationInfo.getEducationInstitutionTypes()
      ).data;
      const countries = (await educationInfo.getCountries()).data;
      const languages = (await educationInfo.getExamLanguages()).data;
      const localityTypes = (await educationInfo.getLocalityTypes()).data;
      const localities = (await educationInfo.getLocalities()).data;
      const distinctionMarkTypes = (
        await educationInfo.getDistinctionMarkTypes()
      ).data;
      const isApproved = (
        await secretary.checkConfirm(auth.getCurrentUser().id)
      ).data;

      await educationInfo.getAllKatoRegions().then((response) => {
        this.setState({ regions: response.data });
      });

      this.setState(
        {
          educationInstitutionTypes,
          countries,
          languages,
          localityTypes,
          localities,
          distinctionMarkTypes,
          isApproved,
        },
        () => {
          educationInfo.getEducationInfo().then((response) => {
            if (response?.data) {
              const { data } = response;

              this.setState(
                {
                  selectedEducationInstitutionType:
                    data.educationInstitutionType?.id, // Объект
                  selectedCountry: data.country?.id, // Объект
                  selectedLanguage: data.language?.id,

                  selectedGraduationPlaceCity: data.graduationPlaceCity,

                  // Для КЗ
                  selectedKzGraduationLocality: data.kzGraduationLocality?.id, // Объект
                  selectedKzGraduationLocalityType:
                    data.kzGraduationLocality?.localityType.id,
                  selectedKzEducationInstitution:
                    data.kzEducationalInstitution?.id, // Объект
                  kzGraduationCertificateSeries:
                    data.kzGraduationCertificateSeries, // Строка
                  kzGraduationCertificateNumber:
                    data.kzGraduationCertificateNumber, // Строка
                  kzGraduationCertificateAveragePoint:
                    data.kzGraduationCertificateAveragePoint, // Строка

                  graduationQualification: data.graduationQualification,
                  qualificationCommissionDecisionDate: data.qualificationCommissionDecisionDate,
                  russianLangAssessment: data.russianLangAssessment,
                  kazakhLangAssessment: data.kazakhLangAssessment,

                  selectedDistinctionMarkType: data.distinctionMarkType?.id, // Объект

                  // Для иностранцев
                  selectedEducationalInstitution: data.educationalInstitution, // Строка
                  selectedSchoolRegion: data.schoolRegionId?.codePrefix,
                  selectedSchoolStreet: data.schoolAddressId?.id,
                  selectedSchool: data.school?.id,

                  graduationCertificateIssueDate:
                    data.graduationCertificateIssueDate, // Дата
                  graduationCertificateName: data.graduationCertificateName, // Строка

                  nostrificationCertificateNumber:
                    data.nostrificationCertificateNumber, // Строка
                  nostrificationCertificateDate:
                    data.nostrificationCertificateDate, // Дата
                  graduationCertificate: data.graduationCertificate?.id, // Объект
                  copyGraduationCertificate: data.copyGraduationCertificate?.id,
                  graduationCertificateApplication:
                    data.graduationCertificateApplication?.id, // Объект
                  specialityName: data.specialityName, // Строка

                  // Path (путь) загружаемых документов (graduationCertificate и graduationCertificateApplication)
                  graduationCertificatePath: data.graduationCertificate?.path,
                  copyGraduationCertificatePath:
                    data.copyGraduationCertificate?.path,
                  graduationCertificateApplicationPath:
                    data.graduationCertificateApplication?.path,
                  resultText: this.state.countries,
                  resultLanguage: this.state.languages,
                },
                () => {
                  this.setState({
                    loading: false,
                  });
                  if (this.state.selectedEducationalInstitution) {
                    this.setState({
                      customInstitution: true,
                    });
                  }
                }
              );
              data.schoolRegionId?.codePrefix && educationInfo
                .getAllKatoPlacesByRegion(data.schoolRegionId?.codePrefix)
                .then((response) => {
                  this.setState({ schoolStreets: response.data });
                  this.setState({ resultSchoolStreets: response.data });
                });

              data.schoolAddressId?.id && educationInfo
                .getSchoolsByKatoId(data.schoolAddressId?.id)
                .then((response) => {
                  this.setState({ schools: response.data });
                  this.setState({ resultSchools: response.data });
                });
            } else {
              this.setState({
                loading: false,
              });
            }
          });
        }
      );
    })();
  }

  getAllStreetsForSchoolByRegion = (id) => {
    this.props.services.educationInfo
      .getAllKatoPlacesByRegion(id)
      .then((response) => {
        this.setState({ schoolStreets: response.data });
        this.setState({ resultSchoolStreets: response.data });
      });
  };

  getAllKatoSchools = (id) => {
    this.props.services.educationInfo
      .getSchoolsByKatoId(id)
      .then((response) => {
        this.setState({ schools: response.data });
        this.setState({ resultSchools: response.data });
      });
  };

  filter = (e) => {
    const keyword = e.target.value;

    if (keyword !== "") {
      const results = this.state.countries.filter((country) => {
        return country.name.toLowerCase().includes(keyword.toLowerCase());
      });
      this.setState({ resultText: results });
    } else {
      this.setState({ resultText: this.state.countries });
    }

    this.setState({ searchText: keyword });
  };

  handleFocus = () => {
    this.setState({ resultText: this.state.countries });
  };


  filterPlaces = (e) => {
    const keyword = e.target.value;

    if (keyword !== "") {
      const results = this.state.schoolStreets.filter((place) => {
        return place.nameru.toLowerCase().includes(keyword.toLowerCase());
      });
      this.setState({ resultSchoolStreets: results });
    } else {
      this.setState({ resultSchoolStreets: this.state.schoolStreets });
    }

    this.setState({ searchText: keyword });
  };

  filterSchools = (e) => {
    const keyword = e.target.value;

    if (keyword !== "") {
      const results = this.state.schools.filter((schools) => {
        return schools.name.toLowerCase().includes(keyword.toLowerCase());
      });
      this.setState({ resultSchools: results });
    } else {
      this.setState({ resultSchools: this.state.schools });
    }

    this.setState({ searchText: keyword });
  };

  componentDidMount() {
    this.fetchData();
  }

  onSubmit = () => {
    const { state } = this;
    const data = {
      graduationPlaceCity: state.selectedGraduationPlaceCity || null,
      country: state.selectedCountry || null,
      language: state.selectedLanguage || null,
      kzGraduationLocality: state.selectedKzGraduationLocality || null, // Если человек выбрал Казахстан
      educationalInstitution: state.customInstitution
        ? state.selectedEducationalInstitution
        : "",
      distinctionMarkType: state.selectedDistinctionMarkType || null, // Если человек выбрал Казахстан + Выбрал университет
      kzGraduationCertificateSeries:
        state.kzGraduationCertificateSeries || null, // Если человек выбрал Казахстан
      kzGraduationCertificateNumber:
        state.kzGraduationCertificateNumber || null, // Если человек выбрал Казахстан
      kzGraduationCertificateAveragePoint:
        state.kzGraduationCertificateAveragePoint || null, // Если человек выбрал Казахстан

      graduationQualification: state.graduationQualification || null,
      qualificationCommissionDecisionDate: state.qualificationCommissionDecisionDate || null,

      graduationCertificateName: state.graduationCertificateName || null,
      graduationCertificateIssueDate:
        state.graduationCertificateIssueDate || null, // Дата выдачи документа об образовании
      nostrificationCertificateNumber:
        state.nostrificationCertificateNumber || null, // Только для иностранных студеньов (школа)
      nostrificationCertificateDate:
        state.nostrificationCertificateDate || null, // Только для иностранных студеньов (школа)
      graduationCertificate: state.graduationCertificate || null,
      copyGraduationCertificate: state.copyGraduationCertificate || null,
      graduationCertificateApplication:
        state.graduationCertificateApplication || null,
      specialityName: state.specialityName || null, // Наименование специальности (для колледжа и вузов)
      educationInstitutionType: state.selectedEducationInstitutionType || null, // Тип образовательного учреждения
      schoolRegionId: state.selectedSchoolRegion || null,
      schoolAddressId: state.selectedSchoolStreet || null,
      school: state.schools.length ? state.selectedSchool : null,
      kazakhLangAssessment: state.kazakhLangAssessment || null,
      russianLangAssessment: state.russianLangAssessment || null,
    };

    this.props.services.educationInfo
      .postEducationInfo(data)
      .then(() => {
        alert("Ваши данные успешно сохранены");
        this.fetchData();
      })
      .catch(() => alert("В форме присутствуют некорректно заполненные поля"));
  };

  handleKzGraduationCertificateAveragePoint = () => {
    this.setState((prevState) => {
      const totalSumOfMarks =
        prevState.numberOf3 * 3 +
        prevState.numberOf4 * 4 +
        prevState.numberOf5 * 5;
      const totalNumberOfMarks =
        prevState.numberOf3 + prevState.numberOf4 + prevState.numberOf5;

      return {
        kzGraduationCertificateAveragePoint: parseFloat(
          totalSumOfMarks / totalNumberOfMarks
        ).toFixed(2),
      };
    });
  };

  render() {
    const { classes } = this.props;
    if (this.state.loading) {
      return <Loader />;
    }

    const schoolGraduate = (
      <>
        {this.state.selectedCountry &&
          this.state.selectedCountry !==
          this.state.countries.find((country) =>
            country.name.includes("Казахстан")
          ).id && (
            <>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Название образовательного учреждения"
                  onChange={(event) =>
                    this.setState({
                      customInstitution: true,
                      selectedEducationalInstitution: event.target.value,
                    })
                  }
                  value={this.state.selectedEducationalInstitution}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Наименование и номер документа об образовании"
                  onChange={(event) =>
                    this.setState({
                      graduationCertificateName: event.target.value,
                    })
                  }
                  value={this.state.graduationCertificateName}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="date"
                  helperText="Дата выдачи документа об образовании"
                  onChange={(event) =>
                    this.setState({
                      graduationCertificateIssueDate: event.target.value,
                    })
                  }
                  value={this.state.graduationCertificateIssueDate}
                ></TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Диплом (скан)"
                  fileType={Constants.FILE_TYPES.graduationCertificate}
                  file={this.state.graduationCertificate}
                  filePath={this.state.graduationCertificatePath}
                  handleSetFileId={(fileId) =>
                    this.setState({ graduationCertificate: fileId })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Приложение к диплому (скан)"
                  fileType={
                    Constants.FILE_TYPES.graduationCertificateApplication
                  }
                  file={this.state.graduationCertificateApplication}
                  filePath={this.state.graduationCertificateApplicationPath}
                  handleSetFileId={(fileId) =>
                    this.setState({ graduationCertificateApplication: fileId })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="№ свидетельства о нострификации"
                  onChange={(event) =>
                    this.setState({
                      nostrificationCertificateNumber: event.target.value,
                    })
                  }
                  value={this.state.nostrificationCertificateNumber}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="date"
                  helperText="Дата свидетельства о нострификации"
                  onChange={(event) =>
                    this.setState({
                      nostrificationCertificateDate: event.target.value,
                    })
                  }
                  value={this.state.nostrificationCertificateDate}
                />
              </Grid>
            </>
          )}
        {this.state.selectedCountry &&
          this.state.selectedCountry ===
          this.state.countries.find((country) =>
            country.name.includes("Казахстан")
          ).id && ( // Если выбрал страну и этой страной является Казахстан
            <>
              {/* <Grid item xs={12} md={8} lg={10}>
              <TextField
                variant='outlined'
                fullWidth
                select
                label='Место окончания учебного заведения'
                className={classes.txtField}
                onChange={event => this.setState({
                  selectedKzGraduationLocalityType: event.target.value
                })}
                value={this.state.selectedKzGraduationLocalityType}
              >
                <MenuItem value='' disabled>
                  Выберите один из вариантов
                </MenuItem>
                {this.state.localityTypes.map(localityType => (
                  <MenuItem key={localityType.id} value={localityType.id}>
                    {localityType.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={8} lg={10}>
              <TextField
                variant='outlined'
                select
                fullWidth
                label='Населенный пункт или город'
                className={classes.txtField}
                onChange={event => this.setState({
                  selectedKzGraduationLocality: event.target.value
                })}
                value={this.state.selectedKzGraduationLocality}
              >
                <MenuItem value='' disabled>
                  Выберите один из вариантов
                </MenuItem>
                {this.state.localities
                  .filter(locality => locality.localityType.id === this.state.selectedKzGraduationLocalityType)
                  .map(locality => (
                    <MenuItem key={locality.id} value={locality.id}>
                      {locality.name}
                    </MenuItem>
                  ))
                }
              </TextField>
            </Grid> */}
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Регион образовательного учреждения"
                  select
                  children
                  value={this.state.selectedSchoolRegion}
                  onChange={(e) => {
                    this.setState({
                      selectedSchoolRegion: e.target.value,
                    });
                    this.getAllStreetsForSchoolByRegion(e.target.value);
                  }}
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>

                  {this.state.regions?.map((region) => (
                    <MenuItem key={region.id} value={region.codePrefix}>
                      {region.nameru}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Район образовательного учреждения"
                  select
                  SelectProps={{
                    MenuProps: { autoFocus: false },
                  }}
                  value={this.state.selectedSchoolStreet}
                  onChange={(e) => {
                    this.setState({
                      selectedSchoolStreet: e.target.value,
                    });
                    this.getAllKatoSchools(e.target.value);
                  }}
                  onClose={() =>
                    this.setState({
                      searchText: "",
                    })
                  }
                >
                  <ListSubheader>
                    <TextField
                      size="small"
                      autoFocus
                      placeholder="Введите для поиска или выберите в меню"
                      fullWidth
                      onChange={(e) => this.filterPlaces(e)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      inputProps={{
                        style: { backgroundColor: "white" },
                      }}
                    />
                  </ListSubheader>
                  {this.state.resultSchoolStreets?.map((place) => (
                    <MenuItem key={place.id} value={place.id}>
                      {place.nameru}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <Tooltip
                  title="Нажмите эту кнопку если не нашли вашу школу, и введите название снизу"
                  arrow
                  enterDelay={1000}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.setState({
                        customInstitution: !this.state.customInstitution,
                      });
                    }}
                  >
                    {this.state.customInstitution
                      ? "Выбрать из списка"
                      : "Не нашли школу?"}
                  </Button>
                </Tooltip>
              </Grid>
              {this.state.customInstitution ? (
                <Grid item xs={12} md={8} lg={10}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Название образовательного учреждения"
                    className={classes.txtField}
                    onChange={(event) =>
                      this.setState({
                        selectedEducationalInstitution: event.target.value,
                      })
                    }
                    value={this.state.selectedEducationalInstitution}
                  />
                </Grid>
              ) : (
                <Grid item xs={12} md={8} lg={10}>
                  <TextField
                    variant="outlined"
                    select={true}
                    label={"Образовательное учреждение"}
                    SelectProps={{
                      MenuProps: { autoFocus: false },
                    }}
                    fullWidth
                    onChange={(event) => {
                      this.setState({
                        selectedSchool: event.target.value,
                      });
                    }}
                    value={this.state.selectedSchool}
                    onClose={() =>
                      this.setState({
                        searchText: "",
                      })
                    }
                  >
                    <ListSubheader>
                      <TextField
                        size="small"
                        autoFocus
                        placeholder="Введите для поиска или выберите в меню"
                        fullWidth
                        onChange={(e) => this.filterSchools(e)}
                        onKeyDown={(e) => {
                          if (e.key !== "Escape") {
                            e.stopPropagation();
                          }
                        }}
                        inputProps={{
                          style: { backgroundColor: "white" },
                        }}
                      />
                    </ListSubheader>
                    {this.state.resultSchools?.map((school) => (
                      <MenuItem key={school.id} value={school.id}>
                        {school.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Серия аттестата о среднем образовании"
                  className={classes.txtField}
                  onChange={(event) =>
                    this.setState({
                      kzGraduationCertificateSeries: event.target.value,
                    })
                  }
                  value={this.state.kzGraduationCertificateSeries}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Номер аттестата о среднем образовании"
                  className={classes.txtField}
                  onChange={(event) =>
                    this.setState({
                      kzGraduationCertificateNumber: event.target.value,
                    })
                  }
                  value={this.state.kzGraduationCertificateNumber}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="date"
                  helperText="Дата выдачи"
                  value={this.state.graduationCertificateIssueDate}
                  onChange={(event) =>
                    this.setState({
                      graduationCertificateIssueDate: event.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <Typography variant="body2">
                  Средний балл аттестата:{" "}
                  {this.state.kzGraduationCertificateAveragePoint ?? 0}
                </Typography>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="number"
                  helperText='Количество "5"'
                  onChange={(event) =>
                    this.setState(
                      () => ({
                        numberOf5: parseInt(event.target.value),
                      }),
                      this.handleKzGraduationCertificateAveragePoint
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="number"
                  helperText='Количество "4"'
                  onChange={(event) =>
                    this.setState(
                      () => ({
                        numberOf4: parseInt(event.target.value),
                      }),
                      this.handleKzGraduationCertificateAveragePoint
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="number"
                  helperText='Количество "3"'
                  onChange={(event) =>
                    this.setState(
                      () => ({
                        numberOf3: parseInt(event.target.value),
                      }),
                      this.handleKzGraduationCertificateAveragePoint
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  select
                  helperText="Оценка по казахскому языку"
                  value={this.state.kazakhLangAssessment}
                  onChange={(event) =>
                    this.setState({
                      kazakhLangAssessment: event.target.value,
                    })
                  }
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>
                  {assessments?.map((assesment) => (
                    <MenuItem key={assesment.value} value={assesment.value}>
                      {assesment.value}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  select
                  helperText="Оценка по русскому языку"
                  value={this.state.russianLangAssessment}
                  onChange={(event) =>
                    this.setState({
                      russianLangAssessment: event.target.value,
                    })
                  }
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>
                  {assessments?.map((assesment) => (
                    <MenuItem key={assesment.value} value={assesment.value}>
                      {assesment.value}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  select
                  fullWidth
                  label="Знак отличия"
                  onChange={(event) =>
                    this.setState({
                      selectedDistinctionMarkType: event.target.value,
                    })
                  }
                  value={this.state.selectedDistinctionMarkType}
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>
                  {this.state.distinctionMarkTypes
                    .filter(
                      (distinctionMarkType) =>
                        distinctionMarkType.institutionType.id ===
                        this.state.selectedEducationInstitutionType
                    )
                    ?.map((distinctionMarkType) => (
                      <MenuItem
                        key={distinctionMarkType.id}
                        value={distinctionMarkType.id}
                      >
                        {distinctionMarkType.name}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Аттестат (скан)"
                  fileType={Constants.FILE_TYPES.graduationCertificate}
                  file={this.state.graduationCertificate}
                  filePath={this.state.graduationCertificatePath}
                  handleSetFileId={(fileId) =>
                    this.setState({ graduationCertificate: fileId })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Приложение к аттестату (скан)"
                  fileType={
                    Constants.FILE_TYPES.graduationCertificateApplication
                  }
                  file={this.state.graduationCertificateApplication}
                  filePath={this.state.graduationCertificateApplicationPath}
                  handleSetFileId={(fileId) =>
                    this.setState({ graduationCertificateApplication: fileId })
                  }
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Копия аттестата и приложения к аттестату, заверенные нотариусом"
                  fileType={Constants.FILE_TYPES.copyGraduationCertificate}
                  file={this.state.copyGraduationCertificate}
                  filePath={this.state.copyGraduationCertificatePath}
                  handleSetFileId={(fileId) =>
                    this.setState({ copyGraduationCertificate: fileId })
                  }
                />
              </Grid>
            </>
          )}
      </>
    );

    const collegeUniversityGraduate = (
      <>
        {/* <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            select
            SelectProps={{
              MenuProps: { autoFocus: false },
            }}
            fullWidth
            label="Страна, в котором закончил(-а) учебное заведение"
            onChange={(event) =>
              this.setState({
                selectedCountry: event.target.value,
              })
            }
            onClose={() =>
              this.setState({
                searchText: "",
              })
            }
            value={this.state.selectedCountry}
          >
            <ListSubheader>
              <TextField
                size="small"
                autoFocus
                placeholder="Введите для поиска или выберите в меню"
                fullWidth
                onChange={(e) => this.filter(e)}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    e.stopPropagation();
                  }
                }}
                inputProps={{
                  style: { backgroundColor: "white" },
                }}
              />
            </ListSubheader>
            {this.state.resultText?.map((country) => (
              <MenuItem key={country.id} value={country.id}>
                {country.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid> */}
        <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            fullWidth
            onChange={(event) =>
              this.setState({
                //kzGraduationCertificateAveragePoint: event.target.value,
                graduationQualification: event.target.value,
              })
            }
            label="Степень/квалификация"
            className={classes.txtField}
            value={this.state.graduationQualification}
          />
        </Grid>

        <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            fullWidth
            type="date"
            onChange={(event) =>
              this.setState({
                qualificationCommissionDecisionDate: event.target.value,
              })
            }
            label="Дата решения квалификационной комиссии"
            className={classes.txtField}
            value={this.state.qualificationCommissionDecisionDate}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        {this.state.selectedCountry &&
          this.state.selectedCountry ===
          this.state.countries.find((country) =>
            country.name.includes("Казахстан")
          ).id && (
            <>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Регион образовательного учреждения"
                  select
                  children
                  value={this.state.selectedSchoolRegion}
                  onChange={(e) => {
                    this.setState({
                      selectedSchoolRegion: e.target.value,
                    });
                    this.getAllStreetsForSchoolByRegion(e.target.value);
                  }}
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>

                  {this.state.regions?.map((region) => (
                    <MenuItem key={region.id} value={region.codePrefix}>
                      {region.nameru}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Район образовательного учреждения"
                  select
                  SelectProps={{
                    MenuProps: { autoFocus: false },
                  }}
                  value={this.state.selectedSchoolStreet}
                  onChange={(e) => {
                    this.setState({
                      selectedSchoolStreet: e.target.value,
                    });
                    this.getAllKatoSchools(e.target.value);
                  }}
                  onClose={() =>
                    this.setState({
                      searchText: "",
                    })
                  }
                >
                  <ListSubheader>
                    <TextField
                      size="small"
                      autoFocus
                      placeholder="Введите для поиска или выберите в меню"
                      fullWidth
                      onChange={(e) => this.filterPlaces(e)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      inputProps={{
                        style: { backgroundColor: "white" },
                      }}
                    />
                  </ListSubheader>
                  {this.state.resultSchoolStreets?.map((place) => (
                    <MenuItem key={place.id} value={place.id}>
                      {place.nameru}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </>
          )}
        <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            fullWidth
            onChange={(event) =>
              this.setState({
                customInstitution: true,
                selectedEducationalInstitution: event.target.value,
              })
            }
            className={classes.txtField}
            label="Название образовательного учреждения"
            value={this.state.selectedEducationalInstitution}
          />
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            fullWidth
            onChange={(event) =>
              this.setState({
                specialityName: event.target.value,
              })
            }
            label="Название специальности / Образовательной группы"
            value={this.state.specialityName}
          />
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            fullWidth
            onChange={(event) =>
              this.setState({
                kzGraduationCertificateSeries: event.target.value,
              })
            }
            label="Серия диплома"
            value={this.state.kzGraduationCertificateSeries}
          />
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            fullWidth
            onChange={(event) =>
              this.setState({
                kzGraduationCertificateNumber: event.target.value,
              })
            }
            label="Номер диплома"
            value={this.state.kzGraduationCertificateNumber}
          />
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            fullWidth
            onChange={(event) =>
              this.setState({
                graduationCertificateIssueDate: event.target.value,
              })
            }
            type="date"
            helperText="Дата выдачи диплома"
            value={this.state.graduationCertificateIssueDate}
          />
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            fullWidth
            onChange={(event) =>
              this.setState({
                kzGraduationCertificateAveragePoint: event.target.value,
              })
            }
            label="Средний балл диплома(GPA)"
            className={classes.txtField}
            value={this.state.kzGraduationCertificateAveragePoint}
          />
        </Grid>
        {this.state.selectedCountry &&
          this.state.selectedCountry !==
          this.state.countries.find((country) =>
            country.name.includes("Казахстан")
          ).id && (
            <>
              <Grid item xs={12} md={8} lg={10}>
                <FormGroup row>
                  <TextField
                    variant="outlined"
                    type="date"
                    width="35ch"
                    value=""
                    helperText="Дата свидетельства"
                  ></TextField>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked="false"
                        name="nostrofication"
                      ></Checkbox>
                    }
                    label="№ Свидетельства о нострофикации"
                  ></FormControlLabel>
                </FormGroup>
              </Grid>
            </>
          )}
        <Grid item xs={12} md={8} lg={10}>
          <TextField
            variant="outlined"
            select
            fullWidth
            label="Знак отличия"
            onChange={(event) =>
              this.setState({
                selectedDistinctionMarkType: event.target.value,
              })
            }
            value={this.state.selectedDistinctionMarkType}
          >
            <MenuItem value="none" disabled>
              Выберите один из вариантов
            </MenuItem>
            {this.state.distinctionMarkTypes
              .filter(
                (distinctionMarkType) =>
                  distinctionMarkType.institutionType.id ===
                  this.state.selectedEducationInstitutionType
              )
              ?.map((distinctionMarkType) => (
                <MenuItem
                  key={distinctionMarkType.id}
                  value={distinctionMarkType.id}
                >
                  {distinctionMarkType.name}
                </MenuItem>
              ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <FileUpload
            helperText="Диплом (скан)"
            fileType={Constants.FILE_TYPES.graduationCertificate}
            file={this.state.graduationCertificate}
            filePath={this.state.graduationCertificatePath}
            handleSetFileId={(fileId) =>
              this.setState({ graduationCertificate: fileId })
            }
          />
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <FileUpload
            helperText="Приложение к диплому (скан)"
            fileType={Constants.FILE_TYPES.graduationCertificateApplication}
            file={this.state.graduationCertificateApplication}
            filePath={this.state.graduationCertificateApplicationPath}
            handleSetFileId={(fileId) =>
              this.setState({ graduationCertificateApplication: fileId })
            }
          />
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <FileUpload
            helperText="Копия диплома и приложения к диплому, заверенная нотариусом"
            fileType={Constants.FILE_TYPES.copyGraduationCertificate}
            file={this.state.copyGraduationCertificate}
            filePath={this.state.copyGraduationCertificatePath}
            handleSetFileId={(fileId) =>
              this.setState({ copyGraduationCertificate: fileId })
            }
          />
        </Grid>
      </>
    );

    return (
      <>
        <Paper className={classes.pageContent}>
          <form className={classes.root}>
            <Typography variant="h5">Сведения об образовании</Typography>
            <br></br>
            <Grid container justify="center" spacing={3}>
              {this.state.isApproved && (
                <Grid item xs={12}>
                  <Typography align="center" variant="h6">
                    Вы не можете ничего менять, так как ваши данные уже
                    подтверждены
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Закончил образовательное учреждение"
                  className={classes.txtField}
                  select
                  value={this.state.selectedEducationInstitutionType}
                  onChange={(event) =>
                    this.setState({
                      selectedEducationInstitutionType: event.target.value,
                      customInstitution: event.target.value === 1 ? false : true,
                    })
                  }
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>
                  {this.state.educationInstitutionTypes?.map(
                    (educationInstitutionType) => (
                      <MenuItem
                        key={educationInstitutionType.id}
                        value={educationInstitutionType.id}
                      >
                        {educationInstitutionType.name}
                      </MenuItem>
                    )
                  )}
                </TextField>
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  SelectProps={{
                    MenuProps: { autoFocus: false },
                  }}
                  variant="outlined"
                  select
                  fullWidth
                  label="На каком языке обучался в предыдущем образовательном учреждении"
                  onChange={(event) =>
                    this.setState({
                      selectedLanguage: event.target.value,
                    })
                  }
                  onClose={() =>
                    this.setState({
                      searchText: "",
                    })
                  }
                  value={this.state.selectedLanguage}
                >
                  <ListSubheader>
                    <TextField
                      size="small"
                      autoFocus
                      placeholder="Введите для поиска или выберите в меню"
                      fullWidth
                      onChange={(e) => this.filter(e)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      inputProps={{
                        style: { backgroundColor: "white" },
                      }}
                    />
                  </ListSubheader>
                  {this.state.languages?.map((language) => (
                    <MenuItem key={language.id} value={language.id} autoFocus={false}>
                      {language.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  select
                  fullWidth
                  label="Место окончания учебного заведения"
                  onChange={(event) =>
                    this.setState({
                      selectedGraduationPlaceCity: event.target.value,
                    })
                  }
                  value={this.state.selectedGraduationPlaceCity}
                >
                  <MenuItem value={"true"}>Город</MenuItem>
                  <MenuItem value={"false"}>Село</MenuItem>
                </TextField>
              </Grid>


              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  SelectProps={{
                    MenuProps: { autoFocus: false },
                  }}
                  variant="outlined"
                  select
                  fullWidth
                  label="Страна, в котором закончил(-а) учебное заведение"
                  onChange={(event) =>
                    this.setState({
                      selectedCountry: event.target.value,
                    })
                  }
                  onFocus={this.handleFocus}
                  onClose={() =>
                    this.setState({
                      searchText: "",
                    })
                  }
                  value={this.state.selectedCountry}
                >
                  <ListSubheader>
                    <TextField
                      size="small"
                      autoFocus
                      placeholder="Введите для поиска или выберите в меню"
                      fullWidth
                      onChange={(e) => this.filter(e)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                      inputProps={{
                        style: { backgroundColor: "white" },
                      }}
                    />
                  </ListSubheader>
                  {this.state.resultText?.map((country) => (
                    <MenuItem key={country.id} value={country.id} autoFocus={false}>
                      {country.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {this.state.selectedEducationInstitutionType &&
                this.state.selectedEducationInstitutionType === 1 && (
                  <>{schoolGraduate}</>
                )}
              {this.state.selectedEducationInstitutionType &&
                this.state.selectedEducationInstitutionType !== 1 && (
                  <>{collegeUniversityGraduate}</>
                )}
              <Grid item xs={12} md={8} lg={10}>
                <Grid container justify="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onSubmit}
                    disabled={this.state.isApproved}
                  >
                    Сохранить
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </>
    );
  }
}

export default withStyles(styles)(withServices()(EducationInfo));
